import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { ToasterService } from "angular2-toaster";
import { OperatorEntity } from "app/interfaces";
import { OperatorWatcher } from "app/interfaces/v3-jobs-response.entity";
import { ClevertapEventsService } from "app/services";
import { WatcherService } from "app/services/watcher.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

@Component({
  selector: "app-watcher-manager",
  templateUrl: "./watcher-manager.component.html",
  styleUrls: ["./watcher-manager.component.scss"],
})
export class WatcherManagerComponent implements OnInit, OnChanges {
  @Input("jobOfferId") jobOfferId: number;
  @Input("watcher") watcher!: OperatorWatcher;
  @Output() onRefresh: EventEmitter<any> = new EventEmitter<any>();

  public modalRef: BsModalRef;
  public template: TemplateRef<any>;
  public operators: OperatorEntity[] = [];
  public assignTo: number | "unassigned";

  get assignToEmail(): string | boolean {
    if (this.operators.length === 0) {
      return false;
    }

    return this.operators.find((o) => o.id === this.assignTo).email;
  }

  constructor(
    private watcherService: WatcherService,
    private modalService: BsModalService,
    private toasterService: ToasterService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.assignTo = changes.watcher.currentValue
      ? changes.watcher.currentValue.id
      : "unassigned";
  }

  ngOnInit() { }

  async openModal(template: TemplateRef<any>) {
    this.template = template;
    this.operators = [
      {
        email: "UNASSIGNED",
        id: "unassigned",
      } as OperatorEntity,
      ...(await this.watcherService.retrieveOperators().toPromise()),
    ];
    this.modalRef = this.modalService.show(template, {
      class: "modal-lg",
    });
  }

  async submit() {
    if (this.assignTo) {
      if (this.assignTo === "unassigned") {
        try {
          await this.watcherService.deleteWatcher(this.jobOfferId).toPromise();
          this.toasterService.pop("success", "Success");
          this.modalRef.hide();
          ClevertapEventsService.emitEvent("jobOfferOwnerChanged", { owner: "unassigned", jobOfferId: this.jobOfferId });
        } catch (e) {
          this.toasterService.pop("error", "Error");
        }
      } else {
        try {
          await this.watcherService
            .setWatcher(this.jobOfferId, this.assignTo)
            .toPromise();
          ClevertapEventsService.emitEvent("jobOfferOwnerChanged", { owner: this.assignTo, jobOfferId: this.jobOfferId });
          this.toasterService.pop("success", "Success");
          this.modalRef.hide();
        } catch (e) {
          this.toasterService.pop("error", "Error");
        }
      }
    }
  }
}
